import * as api from '../api/reindex';
import { createSelector } from 'reselect';
import { getAuthToken } from './user';
import { getDeployment } from './config';

/* Action Types */
export const REINDEX_CATALOGS_START = 'REINDEX_CATALOGS_START';
export const REINDEX_CATALOGS_SUCCESS = 'REINDEX_CATALOGS_SUCCESS';
export const REINDEX_CATALOGS_ERROR = 'REINDEX_CATALOGS_ERROR';

export const REINDEX_LOTS_START = 'REINDEX_LOTS_START';
export const REINDEX_LOTS_SUCCESS = 'REINDEX_LOTS_SUCCESS';
export const REINDEX_LOTS_ERROR = 'REINDEX_LOTS_ERROR';

/* reducer */
const DEFAULT_STATE = {
    catalogsError: null,
    catalogsLoading: false,
    catalogsResult: null,
    lotsError: null,
    lotsLoading: false,
    lotsResult: null,
};

export default function reducer(state: any = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case REINDEX_CATALOGS_START:
            return { ...state, catalogsError: null, catalogsLoading: true, catalogsResult: null };
        case REINDEX_CATALOGS_SUCCESS:
            return { ...state, catalogsError: null, catalogsLoading: false, catalogsResult: action.payload };
        case REINDEX_CATALOGS_ERROR:
            return { ...state, catalogsError: action.payload, catalogsLoading: false, catalogsResult: null };
        case REINDEX_LOTS_START:
            return { ...state, lotsError: null, lotsLoading: false, lotsResult: null };
        case REINDEX_LOTS_SUCCESS:
            return { ...state, lotsError: null, lotsLoading: false, lotsResult: action.payload };
        case REINDEX_LOTS_ERROR:
            return { ...state, lotsError: action.payload, lotsLoading: false, lotsResult: null };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state) => state.reindex;

export const getCatalogsLoading = createSelector(stateSelector, (state) => state.catalogsLoading);
export const getCatalogsError = createSelector(stateSelector, (state) => state.catalogsError);
export const getCatalogsResult = createSelector(stateSelector, (state) => state.catalogsResult);

export const getLotsLoading = createSelector(stateSelector, (state) => state.lotsLoading);
export const getLotsError = createSelector(stateSelector, (state) => state.lotsError);
export const getLotsResult = createSelector(stateSelector, (state) => state.lotsResult);

/* ACTION CREATORS */
export const reindexCatalogs =
    ({ catalogIds }: { catalogIds: number[] }) =>
    async (dispatch: Function, getState: Function) => {
        try {
            const state = getState();
            const authToken = getAuthToken(state);
            const deployment = getDeployment(state);

            dispatch({ type: REINDEX_CATALOGS_START });

            const response = await api.postReindexCatalogs({ authToken, catalogIds, deployment });
            dispatch({ payload: response, type: REINDEX_CATALOGS_SUCCESS });
        } catch (error) {
            dispatch({ error: true, payload: error, type: REINDEX_CATALOGS_ERROR });
        }
    };

export const reindexLots =
    ({ lotIds }: { lotIds: number[] }) =>
    async (dispatch: Function, getState: Function) => {
        try {
            const state = getState();
            const authToken = getAuthToken(state);
            const deployment = getDeployment(state);

            dispatch({ type: REINDEX_LOTS_START });

            const response = await api.postReindexLots({ authToken, deployment, lotIds });
            dispatch({ payload: response, type: REINDEX_LOTS_SUCCESS });
        } catch (error) {
            dispatch({ error: true, payload: error, type: REINDEX_LOTS_ERROR });
        }
    };
